// test161
(161 && 0);
